import React, { useContext } from 'react';
import classNames from 'classnames';

import Button from '../Button';

import { TabsContext } from './Tabs';
import styles from './Tabs.module.scss';

interface TabProps<T extends string = string> {
  tabId: T;
  children: React.ReactNode;
  className?: string;
  activeClassName?: string;
}

export function Tab({ tabId, children, className, activeClassName }: TabProps) {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('Tab must be used within Tabs.');
  }

  const { activeTab, setActiveTab } = context;
  const isActive = activeTab === tabId;

  return (
    <Button
      key={tabId}
      variant="text"
      isActive={isActive}
      onClick={() => setActiveTab(tabId)}
      className={classNames(styles.tabButton, className, {
        [styles.activeTab]: isActive,
        [activeClassName || styles.activeTab]: isActive,
      })}
      role="tab"
      aria-selected={isActive}
      aria-controls={`tabpanel-${tabId}`}
    >
      {children}
    </Button>
  );
}
